var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vat-settings-loader" },
    _vm._l(_vm.lines, function(line) {
      return _c(
        "div",
        { key: line, staticClass: "vat-settings-loader__line" },
        [
          _c("CompassSkeleton", { staticClass: "vat-settings-loader__label" }),
          _vm._v(" "),
          _c("CompassSkeleton", {
            staticClass: "vat-settings-loader__input",
            attrs: { size: "large" }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }